import React, { useCallback, useEffect, useMemo } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultPUR2010_R01Filter, PUR2010_R01Filter, usePUR2010_R01Store } from 'src/containers/mes/PUR/PUR2010_R01/Store_PUR2010_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deletePUR2010_R01, downloadExcel_PUR2010_R01, getPUR2010_R01AllCount, getPUR2010_R01DetailList, getPUR2010_R01List, getPUR2010_R01One, getPdfBlob_PUR2010_R01, patchPUR2010_R01, postPUR2010_R01 } from "./Api_PUR2010_R01";
import { defaultPUR2010_R01DetailDto, defaultPUR2010_R01HeaderDto, PUR2010_R01DetailDto, PUR2010_R01Dto, PUR2010_R01HeaderDto } from './Dto_PUR2010_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	PUR2010_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';

interface Props {
	gridRef: React.RefObject<AgGridReact<PUR2010_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<PUR2010_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_PUR2010_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

		const { moneyCdList, vatTypeList, wmsCdList, compCdList, customCdList, employeeCdList, itemCdMap } = useCommonCodeStore();

	
	const {
		PUR2010_R01Filter, setPUR2010_R01Filter,
		PUR2010_R01PastFilter, setPUR2010_R01PastFilter,
		PUR2010_R01List, setPUR2010_R01List,
		editPUR2010_R01, setEditPUR2010_R01,
		selectedPUR2010_R01, setSelectedPUR2010_R01, 
		deletedPUR2010_R01DetailList, setDeletedPUR2010_R01DetailList, addDeletedPUR2010_R01DetailList, removeDeletedPUR2010_R01DetailList, 
		selectedPUR2010_R01DetailList, setSelectedPUR2010_R01DetailList, addSelectedPUR2010_R01DetailList, removeSelectedPUR2010_R01DetailList,
		PUR2010_R01DetailList, setPUR2010_R01DetailList, insertPUR2010_R01DetailList,
		originalPUR2010_R01DetailList, setOriginalPUR2010_R01DetailList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		initData,
		setScrollTop, setDetailScrollTop,
	} = usePUR2010_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { printPdfFromBlob } = useQzPrint();

	useFetchActionbarAuth("PUR2010_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedPUR2010_R01 || !selectedPUR2010_R01.purchaseBillNo) {
			showWarning("출력할 매입전표번호를 선택하세요.");
			setMessage("출력할 매입전표번호를 선택하세요.");
			return;
		}
		setLoadingSpinner(true);
		try {
			const blob = await getPdfBlob_PUR2010_R01(selectedPUR2010_R01.purchaseBillNo);
			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, "report1");
				if (ok) {
					showSuccess("PDF 출력을 완료하였습니다.");
				} else {
					const fileURL = URL.createObjectURL(blob);
					const win = window.open(fileURL, "_blank");
					// if (win) win.addEventListener("load", () => win.print());
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, "_blank");
				showSuccess("PDF를 새 탭에서 열었습니다.");
			}
		} catch (error) {
			console.error("Print error:", error);
			showError("PDF 출력 중 오류가 발생했습니다.");
			setMessage("PDF 출력 중 오류가 발생했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedPUR2010_R01, setMessage, printPdfFromBlob, setLoadingSpinner]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedPUR2010_R01) {
			showWarning("선택된 매입전표내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_PUR2010_R01('', selectedPUR2010_R01.purchaseBillNo, PUR2010_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '매입전표 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedPUR2010_R01])

	const getParams = (filter: PUR2010_R01Filter) => {
		const params: Partial<PUR2010_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			customCd: filter.customCd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getPUR2010_R01AllCount(getParams(PUR2010_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [PUR2010_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);		
	
		const responseData = (await getPUR2010_R01List(
			'',
			getParams(PUR2010_R01Filter),
			PUR2010_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as PUR2010_R01HeaderDto[];
		setPUR2010_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedPUR2010_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedPUR2010_R01?.salBillNo)
			);
			setPUR2010_R01PastFilter(PUR2010_R01Filter);
			setLoadingSpinner(false);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
			handleCreateClick();
			setLoadingSpinner(false);
		}
		return responseData;
	}, [PUR2010_R01Filter, PUR2010_R01List, setPUR2010_R01List, setPUR2010_R01PastFilter, setSelectedPUR2010_R01, selectedPUR2010_R01, setScrollTop, setDetailScrollTop])

	const defaultPUR2010_R01HeaderRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PUR2010_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				moneyCdList,
				vatTypeList,
				wmsCdList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultPUR2010_R01HeaderDto };
		}

		return {
			...defaultPUR2010_R01HeaderDto,
			compCd: compCdList[0].compCd,
			vatType: vatTypeList[0].minorCd,
			logicCenter: wmsCdList[0].minorCd,
			moneyCd: moneyCdList[0].minorCd,
		};
	}, [
		compCdList, vatTypeList, moneyCdList, wmsCdList,
		validateCommonCodeLists,
	]);

	const defaultPUR2010_R01DetailRow = useCallback(() => {
		return {
			...defaultPUR2010_R01DetailDto,
			inserted: true,
		}
	}, [defaultPUR2010_R01DetailDto]);

	const fetchOne = useCallback(async () => {
		if (!selectedPUR2010_R01) return;
		setLoadingSpinner(true);
		try {
			const response = await getPUR2010_R01One(selectedPUR2010_R01.purchaseBillNo!);
			setEditPUR2010_R01({ ...response.data.data });
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [selectedPUR2010_R01, setEditPUR2010_R01, setLoadingSpinner])
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedPUR2010_R01DetailList();
		removeSelectedPUR2010_R01DetailList();
		setEditPUR2010_R01({ ...defaultPUR2010_R01HeaderRow() })
	}, [defaultPUR2010_R01HeaderRow, selectedPUR2010_R01])

	const handleDeleteClick = useCallback(() => {

		if (deletedPUR2010_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedPUR2010_R01DetailList(deletedPUR2010_R01DetailList);
			removeSelectedPUR2010_R01DetailList();
			setPUR2010_R01DetailList([...PUR2010_R01DetailList]);
		} else if (selectedPUR2010_R01DetailList.length > 0) {
			addDeletedPUR2010_R01DetailList(selectedPUR2010_R01DetailList);
			removeSelectedPUR2010_R01DetailList(selectedPUR2010_R01DetailList);
		}
	}, [selectedPUR2010_R01DetailList, 
		deletedPUR2010_R01DetailList,
		addDeletedPUR2010_R01DetailList,
		removeDeletedPUR2010_R01DetailList,
		removeSelectedPUR2010_R01DetailList,
		setPUR2010_R01DetailList,
		PUR2010_R01DetailList]);
	
	const handleCreateClick = () => {
		setSelectedPUR2010_R01(undefined);
		setEditPUR2010_R01({ ...defaultPUR2010_R01HeaderRow() })
		setPUR2010_R01DetailList([{...defaultPUR2010_R01DetailRow()}]);
		setDeletedPUR2010_R01DetailList([]);
		setSelectedPUR2010_R01DetailList([]);
		setOriginalPUR2010_R01DetailList([]);
		setDetailScrollTop(null);
	}

	const validateInsertData = (header: PUR2010_R01HeaderDto, detailList: PUR2010_R01DetailDto[]) => {
		
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!header.purchaseDt) {
			showWarning('매입일자를 입력해주세요.'); return false;
		}
		if (!validateString(header.vatType)) {
			showWarning('부가세구분을 선택해주세요.'); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('입고물류센터를 선택해주세요.'); return false;
		}
		if (!header.stockInDt) {
			showWarning('입고일자를 입력해주세요.'); return false;
		}
		if (!validateString(header.empNo)) {
			showWarning('담당자를 선택해주세요.'); return false;
		}
		if (!validateEmployeeCd(header.empNo, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}


		if (detailList.length === 0) {
			showWarning('상세내역을 입력해주세요.'); return false;
		}
		for (const detail of detailList) {
			if (!validateString(detail.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if (detail.billQty === null || detail.billQty === undefined) {
				showWarning('매입수량을 입력해주세요. - ' + detail.itemCd); return false;
			}
			if (
				detail.billPrice === null || detail.billPrice === undefined
				&&
				detail.billPrice < 1
			) {
				showWarning('매입단가를 입력해주세요.'); return false;
			}
			const activeDetailList = detailList.filter(detail => !deletedPUR2010_R01DetailList.includes(detail.itemCd));
			const otherDetailList = activeDetailList.filter((_, index) => index !== detailList.findIndex(detail => detail.itemCd === _.itemCd));
			if (otherDetailList.some(otherDetail => otherDetail.itemCd === detail.itemCd)) {
				showWarning("중복된 품목코드가 있습니다.\n품목코드: " + detail.itemCd);
				return false;
			}
			if (!itemCdMap.has(detail.itemCd)) {
				showWarning('품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + detail.itemCd); return false;
			}
		}

		return true;
	}

	const setInfoDetailList = useCallback((header: PUR2010_R01HeaderDto, detailList: PUR2010_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}))
	}, [setPUR2010_R01DetailList])
	
	const handleSaveClick = useCallback(async () => {

		let valid = true;
		if(!validateInsertData(editPUR2010_R01!, PUR2010_R01DetailList)) valid = false;
		if(!valid) { return; }
		
		const deletedPUR2010_R01DetailList_Number = deletedPUR2010_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: PUR2010_R01DetailDto[] = [];
		let newHeaderList: PUR2010_R01HeaderDto[] = [];
		let responseData: PUR2010_R01Dto = {
			purchaseBillHeaderDto: editPUR2010_R01!,
			purchaseBillDetailDtoList: PUR2010_R01DetailList
		};

		if (selectedPUR2010_R01) {
			newDetailList = PUR2010_R01DetailList.filter(value => 
				!deletedPUR2010_R01DetailList_Number.includes(value.valueIndex)
			);

			if (newDetailList.length === 0) {
				processName = 'delete';
				const deleteResponse = await deletePUR2010_R01(selectedPUR2010_R01.purchaseBillNo);

				newHeaderList = PUR2010_R01List.filter(value => value.purchaseBillNo !== selectedPUR2010_R01.purchaseBillNo);

				if (deleteResponse && deleteResponse.data) {
					if (deleteResponse.data.successFlag) {
						showSuccess('매입전표 삭제가 성공하였습니다.');
						setMessage('매입전표 삭제가 성공하였습니다.');
					}else return;
				}
			} else {
				processName = 'patch';
				const patchResponse = await patchPUR2010_R01({
					purchaseBillHeaderDto: editPUR2010_R01!,
					purchaseBillDetailDtoList: setInfoDetailList(editPUR2010_R01!, newDetailList)
				});

				responseData = patchResponse.data.data[0];
				newHeaderList = PUR2010_R01List.map(value => {
					if (value.purchaseBillNo === responseData.purchaseBillHeaderDto.purchaseBillNo) {
						return responseData.purchaseBillHeaderDto;
					}
					return value;
				});
				
				if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {

					showSuccess('매입전표 수정에 성공하였습니다.');
					setMessage('매입전표 수정에 성공하였습니다.');
				}else {
					// 서버 응답이 예상과 다를 경우의 에러 처리
					showWarning('매입전표 수정 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					return;
				}
			}
		} else {
			processName = 'post';
			const postResponse = await postPUR2010_R01({
				purchaseBillHeaderDto: editPUR2010_R01!,
				purchaseBillDetailDtoList: setInfoDetailList(editPUR2010_R01!, PUR2010_R01DetailList)
			});
			responseData = postResponse.data.data[0];

			newHeaderList = [
				...PUR2010_R01List,
				responseData.purchaseBillHeaderDto, // responseData에서 헤더를 가져옵니다.
			] as PUR2010_R01HeaderDto[];
			
			if (postResponse?.data?.data?.[0] && postResponse.data.successFlag) {
				showSuccess('매입전표 등록에 성공하였습니다.');
				setMessage('매입전표 등록에 성공하였습니다.');
			}else {
				// 서버 응답이 예상과 다를 경우의 에러 처리
				showWarning('매입전표 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
				return;
			}
		}


		if (processName === 'delete') {
			setPUR2010_R01List(newHeaderList);
			setSelectedPUR2010_R01(undefined);
			setPUR2010_R01DetailList([]);
			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setPUR2010_R01List(newHeaderList);
			setPUR2010_R01DetailList(responseData.purchaseBillDetailDtoList);
			
			setSelectedPUR2010_R01(responseData.purchaseBillHeaderDto);
			setOriginalPUR2010_R01DetailList(responseData.purchaseBillDetailDtoList);
		}

		// setSelectedPUR2010_R01(undefined);
		setDeletedPUR2010_R01DetailList([]);
		setSelectedPUR2010_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
	
	}, [
		editPUR2010_R01, 
		selectedPUR2010_R01, 
		PUR2010_R01DetailList, 
		deletedPUR2010_R01DetailList, 
		PUR2010_R01List, setPUR2010_R01List
	])

	useEffect(() => {
	
		const fetchDetailList = async (salBillNo: string) => {
			if (!detailFetchTrigger) return;
			setDetailScrollTop(null);
			const responseData = (await getPUR2010_R01DetailList(salBillNo)).data.data;
			if(responseData && responseData.length > 0){
				setPUR2010_R01DetailList(responseData.map((value, idx) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
					billPrice: value.billPrice,
				})));
				setOriginalPUR2010_R01DetailList(responseData);
				setMessage(`${selectedPUR2010_R01?.customNm}의 매입전표내역 ${responseData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);
			}else{
				showError('상세내역이 없습니다.');
				setPUR2010_R01DetailList([]);
				insertPUR2010_R01DetailList([{ ...defaultPUR2010_R01DetailRow() }]);
			}
			setDetailFetchTrigger(false);
		}
	
		if (selectedPUR2010_R01) {
			fetchOne();
			fetchDetailList(selectedPUR2010_R01.purchaseBillNo!)
		}
	}, [selectedPUR2010_R01])

	useEffect(() => {
		if (selectedPUR2010_R01 && PUR2010_R01DetailList.length === 0) {
			insertPUR2010_R01DetailList([{ ...defaultPUR2010_R01DetailRow() }])
		}
	}, [selectedPUR2010_R01, PUR2010_R01DetailList])
	
	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultPUR2010_R01HeaderRow,
		defaultPUR2010_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
